import { memo, useCallback } from 'react'
import { cn } from '@/shared/lib/utils'
import { useTelegram } from '@/shared/lib/telegram'

const PRESETS = [
  { label: 'С днём рождения', text: 'С днём рождения! Пусть каждая чашка чая приносит тепло и вдохновение.' },
  { label: 'Спасибо', text: 'Спасибо за всё! Этот чай — маленькая благодарность от всего сердца.' },
  { label: 'С праздником', text: 'С праздником! Желаю уюта, тепла и самых вкусных чаёв.' },
  { label: 'Просто так', text: 'Просто хочу порадовать тебя. Завари чашку чая и наслаждайся моментом.' },
  { label: 'С Новым годом', text: 'С Новым годом! Пусть он будет тёплым, как хороший пуэр.' },
  { label: 'С 8 марта', text: 'С 8 марта! Ты прекрасна, как весенний улун. Наслаждайся!' },
]

interface GreetingPresetsProps {
  value: string
  onChange: (text: string) => void
}

export const GreetingPresets = memo(function GreetingPresets({ value, onChange }: GreetingPresetsProps) {
  const { hapticFeedback } = useTelegram()

  const handlePresetClick = useCallback((text: string) => {
    hapticFeedback.impactOccurred('light')
    onChange(text)
  }, [hapticFeedback, onChange])

  return (
    <div>
      {/* Preset chips */}
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-none">
        {PRESETS.map((g) => (
          <button
            key={g.label}
            type="button"
            onClick={() => handlePresetClick(g.text)}
            className={cn(
              'shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-all border whitespace-nowrap',
              value === g.text
                ? 'bg-[var(--tg-theme-button-color,#1A1A1A)] text-[var(--tg-theme-button-text-color,#FFFFFF)] border-transparent'
                : 'bg-[var(--tg-theme-bg-color,#FFFFFF)] text-[var(--tg-theme-text-color,#1A1A1A)]/70 border-[var(--tg-theme-hint-color,#999999)]/30'
            )}
          >
            {g.label}
          </button>
        ))}
      </div>

      {/* Custom textarea */}
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Или напишите своё..."
        rows={2}
        maxLength={500}
        className={cn(
          'w-full mt-2 px-4 py-3 rounded-xl border text-sm outline-none transition-all resize-none',
          'bg-[var(--tg-theme-secondary-bg-color,#F5F5F5)] text-[var(--tg-theme-text-color,#1A1A1A)]',
          'placeholder:text-[var(--tg-theme-hint-color,#999999)]',
          'border-[var(--tg-theme-hint-color,#999999)]/30',
          'focus:border-[var(--tg-theme-button-color,#1A1A1A)]/50'
        )}
      />
      {value.length > 0 && (
        <p className="text-[10px] text-[var(--tg-theme-hint-color,#999999)] text-right mt-1">{value.length}/500</p>
      )}
    </div>
  )
})
